import React, { useState } from 'react';
import { NumPadModal } from '../../../../../components/NumPad/NumPad';
import type { AreaView } from '../../../../../services/areas/areas.service';
import { findTableByNumber } from './table-jump.utils';

type TableJumpModalProps = {
  isOpen: boolean;
  areas: AreaView[];
  onClose: () => void;
  onJump: (tableId: number, tableLabel: string) => void;
};

// Summary: Keypad that enters a table by its number through the canvas-tap entry path.
export const TableJumpModal: React.FC<TableJumpModalProps> = ({ isOpen, areas, onClose, onJump }) => {
  const [error, setError] = useState<string | null>(null);

  const close = () => {
    setError(null);
    onClose();
  };

  const handleConfirm = (digits: string) => {
    const table = findTableByNumber(areas, digits);
    if (!table) {
      setError(`שולחן ${digits} לא נמצא`);
      return;
    }
    close();
    onJump(table.id, table.number);
  };

  return (
    <NumPadModal
      isOpen={isOpen}
      title="קפוץ לשולחן"
      subjectName="הכנס מספר שולחן"
      allowUnlimited={false}
      minValue={1}
      maxDigits={4}
      confirmLabel="כניסה"
      error={error}
      dataTestId="table-jump"
      onBufferChange={() => setError(null)}
      onClose={close}
      onConfirmRaw={handleConfirm}
    />
  );
};
